/** Filigrane global (ne bloque pas les clics sur boutons — pointer-events: none) */
export function ContentProtectionOverlay() {
  return (
    <div
      aria-hidden
      className="content-protection-watermark"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9998,
        pointerEvents: 'none',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: '-40%',
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '6rem 8rem',
          transform: 'rotate(-28deg)',
          opacity: 0.035,
          userSelect: 'none',
        }}
      >
        {Array.from({ length: 12 }).map((_, i) => (
          <span
            key={i}
            className="text-gray-900 font-semibold uppercase tracking-[0.35em] text-xs whitespace-nowrap"
          >
            L Benna · Confidentiel
          </span>
        ))}
      </div>
    </div>
  );
}
